// French dictionary.
// Empty for now — keys not present here fall back automatically to the English
// dictionary in I18nProvider. Add French translations as they become available.
const fr: Record<string, string> = {};
export default fr;
